import baseClient, { baseApiCheck } from "./client";
import baseLoginClient from "./loginClient";
import { isEmpty, setParam, setParam2 } from "../utils/comm";
import awsconfig from "../auth/awsconfig";
import baseBasicAuthClient from "./basicAuthClient";
import { CognitoUserPool, CognitoUser } from "amazon-cognito-identity-js"

export const apiGet = async (url, model) => {
  const loginUser = await baseApiCheck();
  return baseClient
    .get(url, model)
    .then((res) => {
      if (res != null && res.data.code === 0) {
        res.data.data.forEach((item, index) => {
          res.data.data[index] = Object.assign(item, { key: index });
        });
      }

      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

export const apiPost = async (url, model) => {
  const loginUser = await baseApiCheck();

  return baseClient
    .post(url, model)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

export const apiPut = async (url, model) => {
  const loginUser = await baseApiCheck();

  return baseClient
    .put(url, model)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// Zone del
export const delZone = async (model) => {
  const loginUser = await baseApiCheck();

  return baseClient
    .put("Zones", model)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [로그인]: 로그인 실행
// [SVC-0103031002] POST Users/Login
export const apiPostUsersLogin = (model) => {
  return baseLoginClient
    .post("Users/Login", model)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [로그인]: 비밀번호 변경
export const apiPostUsersChangepw = (model) => {
  return baseLoginClient
    .post("Users/Changepw", model)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [SVC-0103031004] POST Users/auth
// 사용자 검증
export const apiPostUsersAuth = (model) => {
  const req = {
    userNm: model.userNm,
    tel1: model.tel1,
    email: model.email,
  };

  return baseLoginClient
    .post("Users/auth", req)
    .then((res) => {
      if (res != null && res.data != null) {
        return res.data;
      } else {
        return null;
      }
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [공통 드롭박스]: 사업장
export const apiGetSitesComp = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));

  const loginUser = await baseApiCheck();
  return baseClient
    .get("Sites/comp/" + jsonObj.compId + "/" + jsonObj.userId, {})
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [공통 드롭박스]: 서비스
export const apiGetServiceCode = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .get("Service/" + jsonObj.siteId + "/" + jsonObj.userId, {})
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// 공통코드 조회
export const apiGetMasterCode = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .get("Mastcode/" + jsonObj.catCd, {})
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [SVC-0104014041] 서비스별 사용중인 장비코드 조회
export const apiGetSvcEqui = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .get(`Service/Use/Catalog/${jsonObj.siteId}?catCd=${jsonObj.catCd}`, {})
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};


// [이벤트 관리]: 이벤트 목록 조회(SVC-0106014002)
export const apiGetEvent = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .get("Event/" + jsonObj.siteId, {
      params: {
        svcCdList: setParam(jsonObj.svcCdList),
        codeNm: setParam(jsonObj.codeNm),
        evtZnNm: setParam(jsonObj.evtZnNm),
        devId: setParam(jsonObj.devId),
        startDt: setParam(jsonObj.startDt),
        endDt: setParam(jsonObj.endDt),
        sort: setParam(jsonObj.sort),
      },
    })
    .then((res) => {
      if (res != null && res.data.code === 0) {
        res.data.data.forEach((item, index) => {
          res.data.data[index] = Object.assign(item, { key: index });
        });
      }

      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [이벤트 관리]: 이벤트 상황 조회
export const apiGetEventAction = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .get(
      "Event/action/" + jsonObj.evtId
      //model
    )
    .then((res) => {
      if (res != null && (res.data.code === 0 || res.data.code === 10)) {
        res.data.data.forEach((item, index) => {
          res.data.data[index] = Object.assign(item, { key: index });
        });
      }

      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};
// MMS API (이벤트 상황 조회)
export const apiBasicAuthGetEventAction = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));

  return baseBasicAuthClient
    .get(
      "Event/action/" + jsonObj.evtId
      //model
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};
// MMS API (마스터 코드)
export const apiBasicAuthGetMastCode = async (catCd) => {
  return baseBasicAuthClient
    .get("Mastcode/" + catCd, {})
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// 0106014004 [이벤트 관리]: 이벤트 갯수 조회
export const apiGetEventRead = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  // const loginUser = await baseApiCheck();

  return baseClient
    .get("Event/read/" + jsonObj.siteId, {
      params: {
        svcCd: jsonObj.svcCd,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// 0106014006 [이벤트 관리]: vision device별 통계 이벤트 목록 조회
export const apiGetDeviceEvents = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  // const loginUser = await baseApiCheck();

  return baseClient
    .get("Event/count/device/" + jsonObj.siteId + "/" + jsonObj.svcCd + "/" + jsonObj.znId, {
      params: {
        startDt: setParam(jsonObj.startDt),
        endDt: setParam(jsonObj.endDt),
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [디바이스 상태 관리]: 디바이스 상태 조회(SVC-0105014002)
export const apiGetDeviceStat = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .get("Device/" + jsonObj.siteId, {
      params: {
        svcCdList: setParam(jsonObj.svcCdList),
        searchKeyword: setParam(jsonObj.searchKeyword),
        sort: setParam(jsonObj.sort),
      },
    })
    .then((res) => {
      if (res != null && res.data.code === 0) {
        res.data.data.forEach((item, index) => {
          res.data.data[index] = Object.assign(item, { key: index });
        });
      }

      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [디바이스 상태 관리]: 디바이스 카메라 조회
export const apiGetDeviceStatCam = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .get(
      "Device/stat/" + jsonObj.siteId + "/" + jsonObj.devId
      //model
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [디바이스 상태 관리]: 디바이스 오류 갯수 조회
export const apiGetDeviceError = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .get(
      "Device/error/" + jsonObj.siteId
      //model
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [디바이스 등록 관리]: 디바이스 목록 조회(SVC-0105014001)
export const apiGetDevice = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .get("Device/list/" + jsonObj.siteId, {
      params: {
        svcCdList: setParam(jsonObj.svcCdList),
      },
    })
    .then((res) => {
      if (res != null && res.data.code === 0) {
        res.data.data.forEach((item, index) => {
          res.data.data[index] = Object.assign(item, { key: index });
        });
      }

      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [디바이스 등록 관리]: 디바이스 수정 [SVC-0105012001] PUT Device
export const apiPutDeviceUpdate = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .put("Device", model)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [구역관리 드롭박스]
export const apiGetZonesDrop = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  if(jsonObj.siteId==null) return;

  return baseClient
    .get("Zones/list/" + jsonObj.siteId, {
      params: {
        svcCdList: setParam(jsonObj.svcCdList),
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

/**
 * 서비스 이용자 추가
 * Users > [SVC-0103011001] POST Users
 * 수정기능 포함 (ID 및 email 기재하면 서버에서 자동으로 수정으로 처리)
 * 사이트아이디, 계열사아이디, 권한코드, 이메일, 사용자 이름, 전화번호, 이메일 필수
 * @param model
 * @returns {{code: number, data: null, message: string}}
 */
export const apiPostUsers = async (model) => {
  const loginUser = await baseApiCheck();
  const compId = parseInt(loginUser.info.compId);
  const compNm = loginUser.info.compNm;
  const siteId = parseInt(model.siteId);
  const authCd = model.authCd;
  const email = model.email;
  const userNm = model.userNm;
  const tel1 = model.tel1;
  const dept = model.dept;
  const userId = model.userId;
  const useYn = isEmpty(model.userId) || model.use === null ? "Y" : model.use ? "Y" : "N";
  const mmsYn = isEmpty(model.userId) || model.mms === null || isEmpty(model.tel1) ? "N" : model.mms ? "Y" : "N";

  const body = {
    siteId: setParam2(siteId),
    compId: setParam2(compId),
    compNm: setParam2(compNm),
    authCd: setParam2(authCd),
    email: setParam2(email),
    userNm: setParam2(userNm),
    tel1: setParam2(tel1),
    dept: setParam2(dept),
    useYn: setParam2(useYn),
    userId: setParam2(userId),
    mmsYn: setParam2(mmsYn),
  };

  return baseClient
    .post("Users", body)
    .then(async (res) => {
      if (res.data != null && res.data.code != null && res.data.code === 0) {
        const params = {
            "userid": res.data.data,
            "username": userNm,
            "email": email,
            "password": "TempPassword123!@",
          }
        await cognitoPostUser(params);
      }
      return res.data;
    })
    .catch((err) => {
      if (err.response) {
        return err.response;
      }
    });
};

/**
 * cognito 사용자 추가 함수 분리
 * @param model 
 * @returns {{code: number, data: null, message: string}}
 */
export const cognitoPostUser = async (model) => {
  return baseClient.post("userAdd", model)
  .then((res) => { return res.data; })
  .catch((err) => { if (err) return err; });  
}

/**
 * 사용자 삭제
 * Users > [SVC-0103013001] DELETE Users/{loginId}/{userId}
 * @param model
 * @returns {{code: number, data: null, message: string}}
 */
export const apiDeleteUsers = async (model) => {
  const userId = model.userId;

  return baseClient
    .delete("Users/" + userId, {
      data: model,
    })
    .then(async (res) => {
      if (res.data.code != null && res.data.code === 0) {

        baseClient.post("userDelete", {
          username: userId,
        })
        .then((res) => { return res.data; })
        .catch((err) => { if (err) return err; });
        return res.data;
      } else {
        return null;
      }
    })
    .catch((err) => {
      if (err.response) {
        return err.response;
      }
    });
};

/**
 * 사용자 목록 조회
 * 3)	[SVC-0103014001] GET Users/{userId}/{compId}?siteId=&?searchKeyword=&?sort=
 * @param model
 * @returns {[{tel1: string, authCd: string, useYn: string, dept: string, userName: string, createDt: string, userId: string, email: string}, {tel1: string, authCd: string, useYn: string, dept: string, userName: string, createDt: string, userId: string, email: string}, {tel1: string, authCd: string, useYn: string, dept: string, userName: string, createDt: string, userId: string, email: string}]}
 */
export const apiGetUsers = async (model) => {
  // const jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  // Start of Auth 데이터
  const userId = setParam(loginUser.info.userId); // 로그인한 사용자아이디
  const compId = setParam(loginUser.info.compId); // 회사 아이디 (로그인한 사용자가 속한 회사)
  // End of Auth 데이터

  // Start of parameter 데이터
  const siteId = setParam(model.siteId); // 사업장 아이디
  const searchKeyword = setParam(model.searchKeyword); // 사업장 아이디
  const sort = setParam(model.sort); // 사업장 아이디
  // End of parameter 데이터

  const url = "Users/" + userId + "/" + compId;

  return baseClient
    .get(url, {
      params: {
        siteId: siteId,
        searchKeyword: searchKeyword,
        sort: sort,
      },
    })
    .then((res) => {
      if (res != null && res.data.code === 0) {
        res.data.data.forEach((item, index) => {
          res.data.data[index] = Object.assign(item, { key: index });
        });
      }

      return res.data;
    })
    .catch((err) => {});
};

export const apiGetPath = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .get(model, {})
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};
export const apiPostPath = async (url, model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .post(url, {
      data: model,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};
export const apiPutPath = async (url, model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .put(url, model)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};
export const apiDelPath = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));
  const loginUser = await baseApiCheck();

  return baseClient
    .delete(model, {})
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

/**
 * 권한 목록 조회
 * 2)	[SVC-0103024001] GET Users/prev/{loginId}
 * @return {Promise<AxiosResponse<any>>}
 */
export const apiGetUsersPrev = async () => {
  const loginUser = await baseApiCheck();

  const loginId = loginUser.info.userId;

  const url = "Users/prev/" + loginId;

  return baseClient
    .get(url)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

export const apiGetServiceAll = async (model) => {
  await baseApiCheck();
  const siteId = model.siteId;

  const url = "Service/all/" + siteId;

  return baseClient
    .get(url)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

export const apiGetUserSvc = async (model) => {
  await baseApiCheck();
  const userId = model.userId;

  const url = "Users/svc/" + userId;

  return baseClient
    .get(url)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};
/**
 * 1)	[SVC-0103021001] POST Users/svc
 * 사용자 서비스 설정
 * @param model
 * @return {Promise<AxiosResponse<any>>}
 */
export const apiPostUserSvc = async (model) => {
  const loginUser = await baseApiCheck();

  return baseClient
    .post("Users/svc", model)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// Construction Equipment (건설장비)
// [SVC-0105031001] POST Equipment 건설장비 추가
export const apiPostEquipment = async (data) => {
  const loginUser = await baseApiCheck();
  return baseClient
    .post("Equipment", data)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [SVC-0105032001] PUT Equipment/{devId} 건설장비 삭제
export const apiPutEquipment = async (devId) => {
  const loginUser = await baseApiCheck();

  return baseClient
    .put("Equipment/" + devId)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [SVC-0105034001] GET  Equipment/{siteId}?svcCdList= 서비스별 건설장비 목록 조회
export const apiGetEquipment = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));

  const loginUser = await baseApiCheck();
  return baseClient
    .get("Equipment/" + jsonObj.siteId, {
      params: {
        svcCdList: setParam(jsonObj.svcCdList),
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [SVC-0105034004] GET Equipment/Notmapping/{siteId} 사이트별 매핑되지 않은 건설장비 목록 조회 [디바이스 등록 장비 목록]
export const apiGetEquipmentNotMapping = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));

  if(jsonObj.siteId==null) return;
  
  const loginUser = await baseApiCheck();
  return baseClient
    .get("Equipment/Notmapping/" + jsonObj.siteId)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};

// [SVC-0105034005] GET Equipment/site/{siteId} 사이트별 건설장비 목록 조회 [장비등록관리 목록]
export const apiGetEquipmentSite = async (model) => {
  let jsonObj = JSON.parse(JSON.stringify(model));

  const loginUser = await baseApiCheck();
  return baseClient
    .get("Equipment/site/" + jsonObj.siteId)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response) return err.response;
    });
};
